export default "__VITE_ASSET__gr$8u8ub__"